import "../css/googleadsense.css";
import { useEffect, useRef, useState } from "react";

const GoogleAd = () => {
  const adtest = process.env.REACT_APP_GOOGLE_AD_ADTEST;
  const isAllowdDomein = window.location.host.includes(
    process.env.REACT_APP_GOOGLE_AD_ALLOWED_URL
  );
  const isInitialized = useRef(false);
  const [bottom, setBottom] = useState("-100px");

  useEffect(() => {
    if (window.adsbygoogle && isAllowdDomein && !isInitialized.current) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (error) {
        console.error(error);
      }
      isInitialized.current = true;
    }
    // 2秒後に広告表示
    setTimeout(() => {
      setBottom("0px");
    }, 2000);
  }, [isAllowdDomein]);

  return (
    <div id="custom-banner" style={{ bottom }}>
      <div className="banner-content">
        <div id="ad">
          {/* adsbygoogle.jsの取得はindex.htmlに記載 */}
          {/* mapplevt広告２ */}
          {isAllowdDomein ? (
            <ins
              className="adsbygoogle"
              style={{ display: "block", width: "100%" }}
              data-ad-client="ca-pub-1639240299651672"
              data-ad-slot="6021070099"
              data-ad-format="horizontal"
              data-full-width-responsive="true"
              data-adtest={adtest}
            ></ins>
          ) : (
            <div>広告スペース</div>
          )}
        </div>
        <button
          id="close-banner"
          onClick={() => {
            setBottom("-100px");
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default GoogleAd;
